
import React from 'react';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import ImagesUpload from '../../Components/Images-Upload/Images-Upload';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';
import ImagemFukyo from '../../Components/Imagem-Fukyo/Imagem-Fukyo';




class CardHighlightDetails extends React.Component {
    constructor(props) {
        super(props);

        this.desabilitaSalvar = this.desabilitaSalvar.bind(this);
        this.carregaInfosDestaques = this.carregaInfosDestaques.bind(this);
        this.onChangeInputDestaque = this.onChangeInputDestaque.bind(this);
        this.salvarDestaque = this.salvarDestaque.bind(this);
        this.toggleModalImagemDestaque = this.toggleModalImagemDestaque.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);


        this.state = {
            tituloDestaque: this.props.itemConteudo.nome || this.props.itemConteudo.titulo,
            descricaoDestaque: this.props.itemConteudo.descricao,
            imagemDestaque: this.props.itemConteudo.imagem,
            linkDestaque: this.props.itemConteudo.link,
            isLoadingDestaque: true,
            sucessoDestaque: false,
            openModalImagemDestaque: false,
            hasError: false,
            errorMessage: ''

        }

        this.Configurations = new Configurations();
    }

    componentDidMount() {
        if (!!this.props.idDestaque) {
            this.carregaInfosDestaques();
        } else this.setState({ isLoadingDestaque: false })
    }

    desabilitaSalvar() {
        const tituloD = !!this.state.tituloDestaque && this.state.tituloDestaque.trim() !== ""
        const descricaoD = !!this.state.descricaoDestaque && this.state.descricaoDestaque.trim() !== ""
        const linkD = !!this.state.linkDestaque && this.state.linkDestaque.trim() !== ""

        if (this.props.tipoDestaque === 5) {
            return !(tituloD && descricaoD && linkD)
        } else {
            return !(tituloD && descricaoD)
        }

    }

    carregaInfosDestaques() {
        this.setState({ isLoadingDestaque: true })
        axios.get(this.Configurations.apiBasePath + `/destaques/${this.props.idDestaque}`).then(response => {
            const { titulo, descricao, imagem, link } = response.data.data;

            this.setState({
                'tituloDestaque': titulo,
                'descricaoDestaque': descricao,
                'imagemDestaque': imagem,
                'linkDestaque': link
            })
        }).catch(this.handleError).finally(() => this.setState({
            isLoadingDestaque: false
        }));
        console.log();
    }

    onChangeInputDestaque(e) {
        const { name, value } = e.target;
        if (name.includes("imagem")) this.setState({ imagemDestaque: value, sucessoDestaque: false })
        else this.setState({ [name]: value, sucessoDestaque: false, });
    }

    salvarDestaque() {
        if (!this.props.flagDestaque) {
            const _salvarDestaque = {
                "tipo": this.props.tipoDestaque,
                "titulo": this.state.tituloDestaque,
                "descricao": this.state.descricaoDestaque,
                "imagem": this.state.imagemDestaque,
                "edicao": !!this.props.match.params.numEdicao ? Number(this.props.match.params.numEdicao) || 1 : undefined,
                "idConteudo": !!this.props.match.params.idArtigo ? this.props.match.params.idArtigo : undefined,
                "idPoadcast": !!this.props.match.params.idPodcastPrograma ? this.props.match.params.idPodcastPrograma : undefined,
                "idEpsodio": !!this.props.match.params.idPodcastEpisodio ? this.props.match.params.idPodcastEpisodio : undefined,
                "idVideoPrograma": !!this.props.match.params.idVideoPrograma ? this.props.match.params.idVideoPrograma : undefined,
                "idVideoEpisodio": !!this.props.match.params.idVideoEpisodio ? this.props.match.params.idVideoEpisodio : undefined,
                "idPublicidade": !!this.props.match.params.idAnuncio ? this.props.match.params.idAnuncio : undefined,
                "link": this.state.linkDestaque,
                "sigla": this.props.sigla,
            };
            this.setState({ isLoadingDestaque: true });

            axios.post(this.Configurations.apiBasePath + `/destaques/novo-destaque/${this.props.plataforma}`, _salvarDestaque)
                .then(response => { this.props.apiConteudo(); this.setState({ sucessoDestaque: true }) })
                .catch(this.handleError)
                .finally(() => { this.setState({ isLoadingDestaque: false }); });
        }
        else {
            this.setState({ isLoadingDestaque: true });
            const { tituloDestaque, descricaoDestaque, imagemDestaque, linkDestaque } = this.state;

            const _body = {
                titulo: tituloDestaque.trim() ? tituloDestaque : undefined,
                descricao: descricaoDestaque.trim() ? descricaoDestaque : undefined,
                imagem: imagemDestaque.trim() ? imagemDestaque : undefined,
                link: (this.props.tipoDestaque === 5 && linkDestaque.trim()) ? linkDestaque : undefined,
                tipo: this.props.tipoDestaque
            };

            axios.put(this.Configurations.apiBasePath + `/destaques/${this.props.idDestaque}`, _body)
                .then(response => { this.props.apiConteudo(); this.setState({ sucessoDestaque: true }) })
                .catch(this.handleError)
                .finally(() => this.setState({ isLoadingDestaque: false }));
        }
    }
    toggleModalImagemDestaque() {
        this.setState({ openModalImagemDestaque: !this.state.openModalImagemDestaque })
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response ? err.response.data.message : 'Erro inesperado.' })
    }

    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }


    render() {
        const {
            tituloDestaque, descricaoDestaque, linkDestaque, imagemDestaque,
            isLoadingDestaque, sucessoDestaque
        } = this.state;

        const {
            onChangeInputDestaque, salvarDestaque, toggleModalImagemDestaque
        } = this;

        const {
            plataforma
        } = this.props;
        return (
            <div className="col-12 px-lg-3">
                <div className="card card-informacoes-destaque-bs-mais">
                    <div className={`${plataforma === 1 ? "classe-bsmais" : "classe-hub"} card-header text-lg-left text-center text-white border-white`}>
                        <strong>Informações de destaque - {plataforma === 1 ? "BS+" : "Hub"} </strong>
                    </div>
                    <div className="card-body text-left">
                        <div className="row d-flex align-items-center">
                            <div className="col-12 col-lg-9">
                                <div className="row">
                                    <div className="col-12 py-3">
                                        <small><small>(*)</small> informações obrigatórias</small>
                                    </div>
                                    <div className="col-12 py-3">
                                        <label>Título<sup><small>(*)</small></sup></label>
                                        <input name="tituloDestaque" type="text" className="form-control" autoComplete="off" value={tituloDestaque} onChange={(e) => onChangeInputDestaque(e, plataforma)} />
                                    </div>
                                    <div className="col-12 py-3">
                                        <label>Descrição<sup><small>(*)</small></sup></label>
                                        <input name="descricaoDestaque" type="text" className="form-control" autoComplete="off" value={descricaoDestaque} onChange={(e) => onChangeInputDestaque(e, plataforma)} />
                                    </div>
                                    {this.props.tipoDestaque === 5 && (
                                        <div className="col-12 py-3">
                                            <label>Link<sup><small>(*)</small></sup></label>
                                            <input name="linkDestaque" type="text" className="form-control" autoComplete="off" value={linkDestaque} onChange={(e) => onChangeInputDestaque(e, plataforma)} />
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="col-12 col-lg-3 text-center">
                                <ImagemFukyo
                                    className={`img img-fluid rounded`}
                                    src={imagemDestaque}
                                    alt={`img-destaque`}
                                />
                                <button className="btn btn-outline-info mt-3" onClick={toggleModalImagemDestaque}>Upload de nova imagem</button>
                            </div>
                        </div>
                    </div>
                    <div className="card-footer text-right">
                        {isLoadingDestaque ? (
                            <div className="row no-gutters">
                                <div className="col-12 text-lg-right text-center">
                                    <div className="spinner-border text-primary" />
                                </div>
                            </div>
                        ) : (
                            <div className="row no-gutters">
                                {/* Desktop */}
                                <div className="col-12 text-lg-right text-center d-none d-lg-block">
                                    {sucessoDestaque && (
                                        <i className="text-success mr-3">Informações de Destaque salvas com sucesso!</i>
                                    )}
                                    <button disabled={this.desabilitaSalvar()} onClick={() => salvarDestaque()} className="btn btn-outline-success">Salvar destaque</button>
                                </div>
                                {/* Mobile */}
                                <div className="col-12 text-lg-right text-center d-lg-none">
                                    {sucessoDestaque && (
                                        <div className="col-12">
                                            <i className="text-success mr-3">Informações salvas com sucesso!</i>
                                        </div>
                                    )}
                                    <div className="col-12 text-center mt-2 mb-2">
                                        <button disabled={this.desabilitaSalvar()} onClick={() => salvarDestaque()} className="btn btn-outline-success">Salvar destaque</button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <Modal className="modal-upload-imagem" size="lg" isOpen={this.state.openModalImagemDestaque} toggle={this.toggleModalImagemDestaque}>
                    <ModalHeader toggle={this.toggleModalImagemDestaque}>
                        Upload de imagem - Destaque
                    </ModalHeader>
                    <ModalBody>
                        <ImagesUpload toggle={this.toggleModalImagemDestaque} onChangeInput={this.onChangeInputDestaque}
                        />
                    </ModalBody>
                </Modal>

                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                />
            </div >
        )
    }
}

export default CardHighlightDetails;